export const matchDetails = [
    {
        "match_info": {
          "match_id": "m69",
          "date": "2025-05-05",
          "venue": "Bharat Ratna Shri Atal Bihari Vajpayee Ekana Cricket Stadium, Lucknow",
          "result": "Kolkata Knight Riders won by 98 runs",
          "player_of_the_match": "Sunil Narine"
        },
        "innings": [
          {
            "team": "Kolkata Knight Riders",
            "score": "235/6",
            "overs": 20.0,
            "run_rate": 11.75,
            "batting": [
              {
                "batter": "Phil Salt",
                "dismissal": "c KL Rahul b Naveen-ul-Haq",
                "runs": 32,
                "balls": 14,
                "fours": 5,
                "sixes": 1,
                "strike_rate": 228.57
              },
              {
                "batter": "Sunil Narine",
                "dismissal": "c Devdutt Padikkal b Ravi Bishnoi",
                "runs": 81,
                "balls": 39,
                "fours": 6,
                "sixes": 7,
                "strike_rate": 207.69
              },
              {
                "batter": "Angkrish Raghuvanshi",
                "dismissal": "c KL Rahul b Yudhvir Singh",
                "runs": 32,
                "balls": 26,
                "fours": 3,
                "sixes": 1,
                "strike_rate": 123.07
              },
              {
                "batter": "Andre Russell",
                "dismissal": "c Krishnappa Gowtham b Naveen-ul-Haq",
                "runs": 12,
                "balls": 8,
                "fours": 1,
                "sixes": 1,
                "strike_rate": 150.00
              },
              {
                "batter": "Rinku Singh",
                "dismissal": "c Marcus Stoinis b Naveen-ul-Haq",
                "runs": 16,
                "balls": 11,
                "fours": 2,
                "sixes": 0,
                "strike_rate": 145.45
              },
              {
                "batter": "Shreyas Iyer",
                "dismissal": "c KL Rahul b Yash Thakur",
                "runs": 23,
                "balls": 15,
                "fours": 3,
                "sixes": 0,
                "strike_rate": 153.33
              },
              {
                "batter": "Ramandeep Singh",
                "dismissal": "not out",
                "runs": 25,
                "balls": 6,
                "fours": 1,
                "sixes": 3,
                "strike_rate": 416.66
              },
              {
                "batter": "Venkatesh Iyer",
                "dismissal": "not out",
                "runs": 1,
                "balls": 1,
                "fours": 0,
                "sixes": 0,
                "strike_rate": 100.00
              }
            ],
            "extras": {
              "wides": 13,
              "total": 13
            },
            "fall_of_wickets": [
              "61-1 (Phil Salt, 4.2 ov)",
              "140-2 (Sunil Narine, 12.0 ov)",
              "167-3 (Andre Russell, 14.2 ov)",
              "171-4 (Angkrish Raghuvanshi, 15.1 ov)",
              "200-5 (Rinku Singh, 18.0 ov)",
              "224-6 (Shreyas Iyer, 19.3 ov)"
            ],
            "bowling": [
              {
                "bowler": "Marcus Stoinis",
                "overs": 2,
                "maidens": 0,
                "runs": 29,
                "wickets": 0,
                "economy": 14.50
              },
              {
                "bowler": "Mohsin Khan",
                "overs": 2,
                "maidens": 0,
                "runs": 28,
                "wickets": 0,
                "economy": 14.00
              },
              {
                "bowler": "Naveen-ul-Haq",
                "overs": 4,
                "maidens": 0,
                "runs": 49,
                "wickets": 3,
                "economy": 12.25
              },
              {
                "bowler": "Yash Thakur",
                "overs": 4,
                "maidens": 0,
                "runs": 46,
                "wickets": 1,
                "economy": 11.50
              },
              {
                "bowler": "Krunal Pandya",
                "overs": 2,
                "maidens": 0,
                "runs": 26,
                "wickets": 0,
                "economy": 13.00
              },
              {
                "bowler": "Ravi Bishnoi",
                "overs": 4,
                "maidens": 0,
                "runs": 33,
                "wickets": 1,
                "economy": 8.25
              },
              {
                "bowler": "Yudhvir Singh",
                "overs": 2,
                "maidens": 0,
                "runs": 24,
                "wickets": 1,
                "economy": 12.00
              }
            ]
          },
          {
            "team": "Lucknow Super Giants",
            "score": "137/10",
            "overs": 16.1,
            "run_rate": 8.47,
            "batting": [
              {
                "batter": "KL Rahul (C)",
                "dismissal": "c Ramandeep Singh b Harshit Rana",
                "runs": 25,
                "balls": 21,
                "fours": 3,
                "sixes": 0,
                "strike_rate": 119.04
              },
              {
                "batter": "Arshin Kulkarni",
                "dismissal": "c Ramandeep Singh b Mitchell Starc",
                "runs": 9,
                "balls": 7,
                "fours": 2,
                "sixes": 0,
                "strike_rate": 128.57
              },
              {
                "batter": "Marcus Stoinis",
                "dismissal": "c Harshit Rana b Andre Russell",
                "runs": 36,
                "balls": 21,
                "fours": 4,
                "sixes": 2,
                "strike_rate": 171.42
              },
              {
                "batter": "Deepak Hooda",
                "dismissal": "lbw b Varun Chakaravarthy",
                "runs": 5,
                "balls": 3,
                "fours": 1,
                "sixes": 0,
                "strike_rate": 166.66
              },
              {
                "batter": "Nicholas Pooran",
                "dismissal": "c Phil Salt b Andre Russell",
                "runs": 10,
                "balls": 8,
                "fours": 0,
                "sixes": 1,
                "strike_rate": 125.00
              },
              {
                "batter": "Ayush Badoni",
                "dismissal": "c Mitchell Starc b Sunil Narine",
                "runs": 15,
                "balls": 12,
                "fours": 0,
                "sixes": 1,
                "strike_rate": 125.00
              },
              {
                "batter": "Ashton Turner",
                "dismissal": "c & b Varun Chakaravarthy",
                "runs": 16,
                "balls": 9,
                "fours": 0,
                "sixes": 2,
                "strike_rate": 177.77
              },
              {
                "batter": "Krunal Pandya",
                "dismissal": "c Phil Salt b Harshit Rana",
                "runs": 5,
                "balls": 6,
                "fours": 0,
                "sixes": 0,
                "strike_rate": 83.33
              },
              {
                "batter": "Yudhvir Singh",
                "dismissal": "c Andre Russell b Varun Chakaravarthy",
                "runs": 7,
                "balls": 7,
                "fours": 0,
                "sixes": 1,
                "strike_rate": 100.00
              },
              {
                "batter": "Ravi Bishnoi",
                "dismissal": "lbw b Harshit Rana",
                "runs": 2,
                "balls": 3,
                "fours": 0,
                "sixes": 0,
                "strike_rate": 66.66
              },
              {
                "batter": "Naveen-ul-Haq",
                "dismissal": "not out",
                "runs": 0,
                "balls": 0,
                "fours": 0,
                "sixes": 0,
                "strike_rate": 0.00
              }
            ],
            "extras": {
              "leg_byes": 1,
              "wides": 6,
              "total": 7
            },
            "fall_of_wickets": [
              "20-1 (Arshin Kulkarni, 2.0 ov)",
              "70-2 (KL Rahul, 7.3 ov)",
              "77-3 (Deepak Hooda, 8.2 ov)",
              "85-4 (Marcus Stoinis, 9.1 ov)",
              "101-5 (Nicholas Pooran, 11.2 ov)",
              "109-6 (Ayush Badoni, 12.3 ov)",
              "125-7 (Ashton Turner, 14.0 ov)",
              "129-8 (Krunal Pandya, 14.4 ov)",
              "137-9 (Yudhvir Singh, 15.5 ov)",
              "137-10 (Ravi Bishnoi, 16.1 ov)"
            ],
            "bowling": [
              {
                "bowler": "Mitchell Starc",
                "overs": 4,
                "maidens": 0,
                "runs": 28,
                "wickets": 1,
                "economy": 7.00
              },
              {
                "bowler": "Harshit Rana",
                "overs": 4,
                "maidens": 0,
                "runs": 24,
                "wickets": 3,
                "economy": 6.00
              },
              {
                "bowler": "Andre Russell",
                "overs": 2,
                "maidens": 0,
                "runs": 17,
                "wickets": 2,
                "economy": 8.50
              },
              {
                "bowler": "Sunil Narine",
                "overs": 3,
                "maidens": 0,
                "runs": 28,
                "wickets": 1,
                "economy": 9.33
              },
              {
                "bowler": "Varun Chakaravarthy",
                "overs": 3.1,
                "maidens": 0,
                "runs": 30,
                "wickets": 3,
                "economy": 9.47
              },
              {
                "bowler": "Suyash Sharma",
                "overs": 0.5,
                "maidens": 0,
                "runs": 3,
                "wickets": 0,
                "economy": 3.60
              }
            ]
          }
        ],
        "summary": {
          "toss": "Lucknow Super Giants won the toss and elected to field",
          "result": "Kolkata Knight Riders won by 98 runs",
          "player_of_the_match": "Sunil Narine",
          "points": {
            "Kolkata Knight Riders": 2,
            "Lucknow Super Giants": 0
          }
        }
      }
      
       
      
      
]